<template>
	<div>

		<el-container>
			<!-- 侧边导航 -->
			<div class="show_aside">
				<leftFold @menu3="menu3" :categ_List="categ_List"></leftFold>
			</div>
			<!-- 右边 -->
			<el-container style="display: flex;flex-direction: column;">
				<!-- 头部 -->
				<div class="head">
					<div class="withinBox">
						<i class="el-icon-refresh buttoni" @click="$router.go(0)"></i>
						<i class="el-icon-user-solid buttoni">{{ userinfo.user_name }}</i>
						<i class="el-icon-s-home buttoni" @click="$router.push('/')">首页</i>
						<i class="el-icon-switch-button buttoni" style="color: #ff0000;" @click="tuichu()">退出</i>
					</div>
				</div>
				<!-- 内容 -->
				<div class="mainBox">
					<el-main class="main1">
						<el-tabs v-model="editableTabsValue" type="card" closable @tab-remove="handleTabsEdit"
							class="elTabs" @tab-click="c_tab">
							<el-tab-pane v-for="(item, index) in editableTabs" :label="item.title" :key="item.index"
								:name="item.index + ''" class="tabFor">
								<iframe :src="item.url" class="ifBox"></iframe>
							</el-tab-pane>
						</el-tabs>

					</el-main>
				</div>
			</el-container>
		</el-container>
		<!-- 手机端侧边栏开关 -->
		<div style="position: fixed;bottom: 8%;left: 4.5%;background-color: rgba(0,0,0,0.6);padding: 6px 10px;border-radius: 2px;"
			class="show_leftButt" @click="drawerShow = !drawerShow">
			<img src="@/assets/xiangyou.png" style="width: 12px;height: 12px;">
		</div>
		<!-- 抽屉 -->
		<el-drawer :visible.sync="drawerShow" direction="ltr" size="50%" :show-close="false">
			<leftFold @menu3="menu3" :categ_List="categ_List"></leftFold>
		</el-drawer>


	</div>
</template>

<script>
import md5 from "@/public/md5"
import leftFold from "@/components/leftFold.vue"
import api from "../public/api.js"
export default {
	components: { leftFold },
	data() {
		return {
			editableTabsValue: '0',
			TabsValue: '',
			editableTabs: [{
				title: '首页',
				url: '#/ht_categ',
				index: 0
			}],
			userinfo: '',
			drawerShow: false,// 侧边栏开关
			pageName: "知识库主体",
			categ_List: [],// 知识库分类
		}
	},
	created() {
		// // 登录
		// api({
		// 	url: '/admin/Login/login',
		// 	data: {
		// 		user_phone: '15012345678',
		// 		user_pass: md5.md5('123456')
		// 	}
		// }).then(res => {})

		let editableTabs = sessionStorage.getItem('editableTabs')
		if (editableTabs) {
			let editableTabsValue = sessionStorage.getItem('editableTabsValue')
			this.editableTabs = JSON.parse(editableTabs)
			this.editableTabsValue = JSON.parse(editableTabsValue)
		}
		// 请求列表数据
		this.api_data()
	},
	mounted() {
		window.thiss = this
		// console.log("window",window.thiss)
		// 使用
		// window.parent.thiss
	},
	methods: {
		c_tab(evt) {
			// 保存旧的index
			// sessionStorage.setItem('editableTabsValue2', sessionStorage.getItem('editableTabsValue'))
			// 用于刷新时保持选中状态
			sessionStorage.setItem('editableTabsValue', JSON.stringify(this.editableTabs[evt.index].index))
		},
		api_data() {
			// 知识库分类
			api({
				url: '/admin/Menu/list'
			}).then(res => {
				this.categ_List = res
			})
			api({
				url: '/admin/User/info'
			}).then(res => {
				this.userinfo = res
			})
		},
		tuichu() {
			this.$confirm('是否退出账号？', '退出账号', {
				distinguishCancelAndClose: true,
				confirmButtonText: '确认',
				cancelButtonText: '取消'
			})
				.then(() => {
					api({
						url: '/admin/User/lout'
					}).then(res => {
						this.$message({
							message: '退出成功',
							type: 'success'
						});
						this.$router.push('/')
					})

				})
				.catch(action => {
					this.$message({
						type: 'info',
						message: '取消退出'
					})
				});

		},
		// 点击三级菜单-添加tab
		menu3(item, url) {
			// article_id 文章id
			// categ_id 分类id
			// console.log("添加tab",item)
			this.drawerShow = false
			// 筛选tab中是否存在当前点击的id
			let result = this.editableTabs.filter(res => {
				// 点击其他页面调用
				if (item.article_id) return res.categ_id == item.article_id
				// 点击分类列表
				else return res.categ_id == item.categ_id
			})
			// 判断是否存在
			if (result.length > 0) {
				// console.log("存在")
				// 存在
				this.editableTabsValue = result[0].index + ''// 用于tab选中
				// 用于页面刷新时保持tab选中
				sessionStorage.setItem('editableTabsValue', JSON.stringify(this.editableTabsValue))
				return
			}
			// console.log("不存在")
			// 不存在 新增到tab列表中
			var data1 = new Date()
			var time = data1.getTime() + ''
			this.editableTabs.push({
				title: item.categ_name,
				url: url + item.categ_id,
				index: time,
				// item.article_id存在表示 其他页面调用 否则 是分类id 
				categ_id: item.article_id ? item.article_id : item.categ_id// 分类id
			})
			var index1 = this.editableTabs.length - 1
			this.editableTabs[index1].index = time
			this.editableTabsValue = time
			sessionStorage.setItem('editableTabs', JSON.stringify(this.editableTabs))
			sessionStorage.setItem('editableTabsValue', JSON.stringify(this.editableTabsValue))
		},
		// tab关闭页面
		handleTabsEdit(tabindex, upData = false) {
			// console.log("要删除的",tabindex)
			let editableTabsValue2 = JSON.parse(sessionStorage.getItem('editableTabsValue2'))
			if (tabindex == 0) {
				this.$message({
					type: 'error',
					message: '首页不能关闭'
				})
				return
			}
			// console.log("tab点击关闭的key",tabindex,sessionStorage.getItem('editableTabsValue2'))
			// 当预备的index被删除时 删除数组中的 editableTabsValue2
			if (editableTabsValue2 == tabindex) sessionStorage.removeItem('editableTabsValue2')
			// 删除后的数组
			let editableTabs = this.editableTabs.filter((item, index) => {
				// 删除 与tabindex相等的
				if (item.index != tabindex) {
					return item
				}
			})
			// console.log("删除后的数组",editableTabs)
			// tab展示的列表
			this.editableTabs = editableTabs
			sessionStorage.setItem('editableTabs', JSON.stringify(this.editableTabs))
			// true表示其他页面调用的 需要刷新页面
			// console.log(editableTabsValue2)
			if (upData) {
				// 刷新页面 重新获取页面数据
				// console.log("列表1",window.parent.thiss.this_articleList1.pageName)
				window.parent.thiss.this_articleList1.api_Article()
				if (window.parent.thiss.this_articleList2) {
					// console.log("列表2",window.parent.thiss.this_articleList2.pageName)
					window.parent.thiss.this_articleList2.api_info()
				}
				// 调用后关闭页面后 把保存的值给 editableTabsValue(用于刷新后显示当前打开的页面)
				this.editableTabsValue = editableTabsValue2
				sessionStorage.setItem('editableTabsValue', sessionStorage.getItem('editableTabsValue2'))
			} else {
				// tab点击关闭 选中的列表
				this.editableTabsValue = editableTabs[editableTabs.length - 1].index + ''
				sessionStorage.setItem('editableTabsValue', JSON.stringify(this.editableTabsValue))
			}
		}
	},
	computed: {
		// 页面路径
		getPageUrl() {
			return this.$route.path
		}
	}
}
</script>

<style scoped lang="less">
@media (max-width: 992px) {
	.show_aside {
		display: none;
	}
}

// pc端
@media (min-width: 993px) {

	// 隐藏 手机端展开侧边栏按钮
	.show_leftButt {
		display: none;
	}
}

// ------------------------------

.head {
	height: 8vh;
	display: flex;
	justify-content: flex-end;
	padding: 0 2%;

	// border: 1px solid #ff0000;
	.withinBox {
		display: flex;
		// border: 1px solid #00aaff;
		margin-left: 2vh;
		display: flex;
		align-items: center;

		.buttoni {
			font-size: 18px;
			cursor: pointer;
			font-size: 20px;
			margin-left: 15px;
		}

		.buttoni:nth-child(1) {
			font-weight: bold;
		}
	}
}

.mainBox {
	padding: 2.5vh;
	background-color: #f3f3f3;
	box-shadow: 0 0 8px 1px rgba(141, 141, 141, 0.1) inset;

	.el-main {
		background-color: #E9EEF3;
		color: #333;
		box-shadow: 0 0 8px 1px rgba(141, 141, 141, 0.1);
	}

	.main1 {
		height: 87vh;
		padding: 0;
		border-radius: 5px;
		background-color: #fff;

		// border: 1px solid #ff0000;
		.elTabs {

			// background-color: #00AAFF;
			.tabFor {

				// border: 1px solid;
				.ifBox {
					height: 80vh;
					width: 100%;
					border: none;
					// border: 1px solid #ff0000;
				}
			}
		}
	}
}

/deep/ .el-tabs__header {
	margin-bottom: 0;
}
</style>
